import { render, staticRenderFns } from "./PrintInvoicePreviewHuawei.vue?vue&type=template&id=16629114"
import script from "./PrintInvoicePreviewHuawei.vue?vue&type=script&lang=js"
export * from "./PrintInvoicePreviewHuawei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports